function localUserId(widgetId) {
  return `widget_id#${widgetId}_User`;
}

function getLocalUser(widgetId) {
  return localStorage.getItem(localUserId(widgetId));
}

function setLocalUser(widgetId, userId) {
  return localStorage.setItem(localUserId(widgetId), userId);
}

export default { getLocalUser, setLocalUser };